import React from 'react'
import styled from 'styled-components'
import { Card } from '@pancakeswap-libs/uikit'

export const BodyWrapper = styled(Card)`
position: relative;
  z-index: 5;
  max-width: 436px;
  width: 100%;
  // background: rgba(81, 81, 81, 0.2);
  background: transparent;
  box-shadow: 3px 10px 9.3px rgba(0, 0, 0, 0.25), 0px 12px 17.1px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(2px);
  border-radius: 40px;
  overflow: hidden; /* clip inner content to border radius */
  padding-top: 5px;

  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border-radius: 40px; /* slightly larger than main card's radius */
    padding: 4px;
    background: linear-gradient(to top, #10622F 32%, #241F64 100%);
    -webkit-mask: 
      linear-gradient(#fff 0 0) content-box, 
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: destination-out;
    mask-composite: exclude;
  }


`

/**
 * The styled container element that wraps the content of most pages and the tabs.
 */
export default function AppBody({ children }: { children: React.ReactNode }) {
  return <BodyWrapper>{children}</BodyWrapper>
}
